<div
    class="portfolio-info pointer"
    [class.portfolio-info--investment-select]="type === 'investment-select'"
    [class.portfolio-info--investment-select--viewed]="type === 'investment-select' && selected"
    [class.portfolio-info--unshared]="!shareColumns"
    [class.contains-instrument-will-be-removed]="investment.containesWillBeRemovedInstrument"
    (click)="selectPortfolio(investment.portfolioId)"
    (keydown.space)="selectPortfolio(investment.portfolioId)"
    (keydown.enter)="selectPortfolio(investment.portfolioId)"
    tabindex="0"
    nz-tooltip
    autoCloseOnScroll
    [nzTooltipTitle]="investment.containesWillBeRemovedInstrument && investment.scheduledInstrumentRemovalDate ? instrumentScheduledForRemovalTooltip : null"
    nzTooltipOverlayClassName="lean"
>
    <ng-template #instrumentScheduledForRemovalTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                <span>{{ 'investmentTile.scheduledForRemoval.part1' | translate }}</span>
                <span>{{ investment.scheduledInstrumentRemovalDate }}</span>
                <span>{{ 'investmentTile.scheduledForRemoval.part2' | translate }}</span>
            </div>
        </liberro-tooltip-content>
    </ng-template>
    <ng-template #investmentValueTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                {{ 'investmentTile.valueTooltip' | translate }}
            </div>
        </liberro-tooltip-content>
    </ng-template>
    <ng-template #investmentValueAbsoluteTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                {{ 'investmentTile.valuePercentTooltip' | translate }}
            </div>
        </liberro-tooltip-content>
    </ng-template>
    <ng-template #investmentValuePercentTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                {{ 'investmentTile.valueAbsoluteTooltip' | translate }}
            </div>
        </liberro-tooltip-content>
    </ng-template>

    <ng-template #avatarTpl>
        <liberro-avatar-photo-tagged [portfolioDetail]="investment"></liberro-avatar-photo-tagged>
    </ng-template>

    <ng-template #portfolioNameTpl>
        <div class="portfolio-name">
            {{ investment.portfolioName }}
        </div>
    </ng-template>

    <ng-template #goalTagsTpl>
        <div class="goal-tags-wrapper">
            @if (investment.portfolioGoal) {
                <span class="goal-wrapper">
                    {{ (investment.portfolioGoal | translate) }}
                </span>
            }
            <liberro-investment-badges
                [investmentInput]="investment"
            ></liberro-investment-badges>
        </div>
    </ng-template>

    <ng-template #portfolioValueTpl>
        <div
            class="portfolio-value"
            [class.financial-value--hidden]="hideFinancialValues()"
            nz-tooltip
            autoCloseOnScroll
            [nzTooltipTitle]="investmentValueTooltip"
            nzTooltipOverlayClassName="lean"
            [nzTooltipVisible]="valueTooltipVisible()"
            (nzTooltipVisibleChange)="valueTooltipToggle($event)"
            (click)="valueTooltipToggle(!valueTooltipVisible())"
        >
            {{ hideFinancialValues() ? investmentTileValue : (investment.value | price: investment.currency) }}
        </div>
    </ng-template>

    <ng-template #portfolioChangesTpl>
        <div class="portfolio-changes">
            <span
                class="absolute"
                nz-tooltip
                autoCloseOnScroll
                [class.portfolio-value-figure--zero]="investment.valueChangeAbsolute === 0"
                [class.portfolio-value-figure--negative]="investment.valueChangeAbsolute < 0"
                [class.portfolio-value-figure--positive]="investment.valueChangeAbsolute > 0"
                [class.financial-value--hidden]="hideFinancialValues()"
                [nzTooltipTitle]="investmentValueAbsoluteTooltip"
                nzTooltipOverlayClassName="lean"
                [nzTooltipVisible]="absoluteValueTooltipVisible()"
                (nzTooltipVisibleChange)="absoluteValueTooltipToggle($event)"
                (click)="absoluteValueTooltipToggle(!absoluteValueTooltipVisible())"
            >
                {{ hideFinancialValues() ? investmentTileProfit : (investment.valueChangeAbsolute | price: investment.currency) }}
            </span>
            <liberro-tagged-text
                [type]="investment.valueChangePercentage <= 0 ? 'grey' : 'success'"
                [class.dark-negative]="investment.valueChangePercentage < 0"
                nz-tooltip
                autoCloseOnScroll
                [nzTooltipTitle]="investmentValuePercentTooltip"
                nzTooltipOverlayClassName="lean"
                [nzTooltipVisible]="percentTooltipVisible()"
                (nzTooltipVisibleChange)="percentTooltipToggle($event)"
                (click)="percentTooltipToggle(!percentTooltipVisible())"
            >
                @let pct = investment.valueChangePercentage;
                {{ pct > 0 ? '+' : '' }}{{ pct | percent:'1.2-2':'cs' }}
            </liberro-tagged-text>
        </div>
    </ng-template>

    @if (shareColumns) {
        <div class="left-row">
            <ng-container *ngTemplateOutlet="avatarTpl"></ng-container>
            <div class="portfolio-preview">
                <ng-container *ngTemplateOutlet="portfolioNameTpl"></ng-container>
                <ng-container *ngTemplateOutlet="goalTagsTpl"></ng-container>
            </div>
        </div>
        <div class="portfolio-stats">
            <ng-container *ngTemplateOutlet="portfolioValueTpl"></ng-container>
            <ng-container *ngTemplateOutlet="portfolioChangesTpl"></ng-container>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="avatarTpl"></ng-container>
        <div class="portfolio-unshared">
            <div class="portfolio-unshared-row">
                <ng-container *ngTemplateOutlet="portfolioNameTpl"></ng-container>
                <ng-container *ngTemplateOutlet="portfolioValueTpl"></ng-container>
            </div>
            <div class="portfolio-unshared-row">
                <ng-container *ngTemplateOutlet="goalTagsTpl"></ng-container>
                <ng-container *ngTemplateOutlet="portfolioChangesTpl"></ng-container>
            </div>
        </div>
    }
</div>
